import { AlertBanner, Colour, useLayout } from '@ukpostbox/frontend-framework';
import { useEffect } from 'react';
import { useAuthorisedUser } from '../../_Auth/Providers/AuthProvider';

function AccountAlertContent() {
	const isWrong = true;
	const { setDefaultLayout, setSidebarHeaderLayout } = useLayout();

	useEffect(() => {
		if (isWrong) {
			setSidebarHeaderLayout();
		} else {
			setDefaultLayout();
		}
	}, []);

	return (
		<AlertBanner title="Your User is overdue, your User will be closed if you don't renew." colour={Colour.Alert} />
	);
}

function AccountAlert() {
	const { token } = useAuthorisedUser();

	if (!token) return null;

	return <AccountAlertContent />;
}

export { AccountAlert };
